<template lang="">
  <div
    class="help-container"
  >
    <ms-popover
      trigger="click"
      placement="bottom"
      :width="popoverSize?.width"
      v-model:visible="visiblePopover"
    >
      <template #reference>
        <img
          class="help"
          :src="help.src"
          :width="help.width"
          :height="help.height"
        >
      </template>
      <template #default>
        <div class="f-full">
          <div class="label p-3">
            {{ $t('Teacher.EMISApps') }}
          </div>
          <div
            class="option-item hover:bg-background-blue rounded"
            v-for="(option, index) in options"
            :key="index"
            @click="option.onClick"
          >
            <img
              :src="option.icon"
              :width="40"
              :height="40"
              class="mt-0.5"
            >
            <div class="ml-3">
              <span class="label">{{ option.text }}</span> <br> {{ option.note }}
            </div>
          </div>
        </div>
      </template>
    </ms-popover>
  </div>
</template>

<script>
import MsPopover from '@/components/popover'
import BaseList from '../base/base-list.vue'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { isShowExamFeature } from '@/common/common-fn'
import { getEnvConfig } from '@/utils/env-variables'
// eslint-disable-next-line no-unused-vars
const copyClassCode = () =>
  import('@/views/pages/teacher/class-room/list/popup-copy-classcode')

export default {
  extends: BaseList,

  components: {
    MsPopover
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      help: {
        src: require('@/assets/icons/svg/user_info/ic_Material.svg'),
        width: 24,
        height: 24
      },
      popoverSize: {
        width: 280
      },
      visiblePopover: false,

      copyClassCode: copyClassCode,

      appEnums: {
        Practice: 0,
        Exam: 1,
        Room: 2,
        ManageStudent: 3
      }
    }
  },

  computed: {
    /**
     * check em có là tài khoản trường cung cấp hay không
     */
    isEMIS () {
      return getContextData(ContextDataKey.IsEMIS)
    },
    isRoleOrganingCommittee () {
      const listRoleContext = getContextData(ContextDataKey.RoleList)
      if (listRoleContext !== '' && listRoleContext !== undefined) {
        const listRoles = JSON.parse(listRoleContext)
        const role = listRoles?.find(x => x.DictionaryKey === this.$enumeration.RoleDictionaryKey.OrganingCommittee)
        return role !== undefined
      }
      return false
    },

    /**
   * ID của người dùng
   */
    userID () {
      return getContextData(ContextDataKey.UserID)
    },

    options () {
      const me = this
      /**
       * Danh sách các option phần sidebar chi tiết học sinh
       */
      let list = [

        {
          iconName: 'ic_homework',
          business: 'HomeWorkEMIS',
          note: 'NoteHomeWork',
          event: me.switchToApp.bind(me, me.appEnums.Practice)
        },

        {
          iconName: 'ic_exam',
          business: 'AnswerEMIS',
          note: 'NoteAnswer',
          event: me.switchToApp.bind(me, me.appEnums.Exam)
        },

        {
          iconName: 'ic_room',
          business: 'RoomEMIS',
          note: 'NoteRoom',
          event: me.switchToApp.bind(me, me.appEnums.Room)
        },
        {
          iconName: 'ic_manage_student',
          business: 'ManangeStudentEMIS',
          note: 'NoteManageStudent',
          event: me.switchToApp.bind(me, me.appEnums.ManageStudent)
        }

      ]

      if (!me.isEMIS) {
        list = list.filter(item => {
          return item.business !== 'EmisStudent' && item.business !== 'ManangeStudentEMIS'
        })
      }

      if (!isShowExamFeature()) {
        list = list.filter(item => {
          return item.business !== 'AnswerEMIS'
        })
      }

      return list.map(option => {
        return {
          icon: require(`@/assets/icons/svg/subsystem/${option.iconName}.svg`),
          text: me.$t(`User.${option.business}`),
          note: me.$t(`User.${option.note}`),
          onClick: option.event
        }
      })
    }

  },

  methods: {

    isShowExamFeature: isShowExamFeature,

    /**
     * @override
     */
    getPopupProps (componentName) {
      const me = this
      const res = {}

      if (componentName === 'DetailPopup') {
        res.openCopyClasscodePopup = me.openCopyClasscodePopup
      }

      return res
    },

    async getOtherPopup (componentName) {
      // eslint-disable-next-line no-eval
      const componentImport = eval(componentName)

      return await componentImport()
    },

    /**
     * @description override base
     */
    getContainer () {
      return this.$refs.container
    },

    /**
     * Hàm ẩn popover thông tin học sinh
     */
    hide () {
      this.visiblePopover = false
    },

    /**
     * chuyển tới app
     */
    switchToApp (appEnum) {
      const me = this
      // case kèo với từng phân hệ
      switch (appEnum) {
        case me.appEnums?.Practice:
          me.$router.push('/teacher/dashboard')
          break
        case me.appEnums?.Exam:
          me.$router.push('/teacher/school-exam-period')
          // if (me.isRoleOrganingCommittee) {
          //   me.$router.push('/teacher/school-exam-period')
          // } else {
          //   me.$router.push('/teacher/exam-period')
          // }
          break
        case me.appEnums?.Room:
          me.$router.push('/teacher/online-classroom')
          break
        case me.appEnums?.ManageStudent:
          window.open(getEnvConfig('misaManageStudent'))
          break
      }
      me.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.help-container {
  height: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.option-item{
  display: flex;
  cursor: pointer;
  padding: 10px;
}
.ms-popper{
  margin-top: 20px !important;
}
</style>
